"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FourCorners = exports.FourCornersStyled = exports.default = exports.ExpandingBoundingBoxHoverState = exports.ExpandingBoundingBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _hotspotGlobal = require("../hotspot.global.styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ANIMATION_SPEED = 150;
var TRANSITION_STYLE = 'cubic-bezier(0.95, 0.05, 0.795, 0.035)';
var TRANSITION_STYLE_AFTER = 'ease';

var setBorderColor = function setBorderColor(borderColor) {
  return borderColor || _hotspotGlobal.colors.black;
};

var ExpandingBoundingBox = _styledComponents.default.div.withConfig({
  displayName: "bounding-box__ExpandingBoundingBox",
  componentId: "sc-1fdulxe-0"
})(["height:100%;position:relative;width:100%;&:before,&:after{content:'';display:block;height:0;width:0;box-sizing:border-box;position:absolute;}&:before{border-right:0 solid ", ";border-top:0 solid ", ";left:0;top:0;transition:width ", "ms ", " ", "ms,height ", "ms ", " ", "ms,visibility 0s ", "ms;}&:after{bottom:0;border-bottom:0 solid ", ";border-left:0 solid ", ";right:0;transition:width ", "ms ", " ", "ms,height ", "ms ", ",visibility 0s ", "ms;}"], function (_ref) {
  var borderColor = _ref.borderColor;
  return setBorderColor(borderColor);
}, function (_ref2) {
  var borderColor = _ref2.borderColor;
  return setBorderColor(borderColor);
}, ANIMATION_SPEED, TRANSITION_STYLE, ANIMATION_SPEED * 3, ANIMATION_SPEED, TRANSITION_STYLE, ANIMATION_SPEED * 2, ANIMATION_SPEED * 4, function (_ref3) {
  var borderColor = _ref3.borderColor;
  return setBorderColor(borderColor);
}, function (_ref4) {
  var borderColor = _ref4.borderColor;
  return setBorderColor(borderColor);
}, ANIMATION_SPEED, TRANSITION_STYLE_AFTER, ANIMATION_SPEED, ANIMATION_SPEED, TRANSITION_STYLE_AFTER, ANIMATION_SPEED * 2);

exports.ExpandingBoundingBox = ExpandingBoundingBox;
var ExpandingBoundingBoxHoverState = "\n  &:before {\n    border-width: 1px;\n    height: 100%;\n    transition: width ".concat(ANIMATION_SPEED, "ms ").concat(TRANSITION_STYLE, ", height ").concat(ANIMATION_SPEED, "ms ").concat(TRANSITION_STYLE, " ").concat(ANIMATION_SPEED, "ms;\n    width: 100%;\n  }\n  &:after {\n    border-width: 1px;\n    height: 100%;\n    transition: width ").concat(ANIMATION_SPEED, "ms ease ").concat(ANIMATION_SPEED * 2, "ms, height ").concat(ANIMATION_SPEED, "ms ease ").concat(ANIMATION_SPEED * 3, "ms, visibility 0s ").concat(ANIMATION_SPEED * 2, "ms;\n    width: 100%;\n  }\n");
exports.ExpandingBoundingBoxHoverState = ExpandingBoundingBoxHoverState;

var BoundingBox = _styledComponents.default.div.withConfig({
  displayName: "bounding-box__BoundingBox",
  componentId: "sc-1fdulxe-1"
})(["height:", ";width:", ";"], function (props) {
  return props.height;
}, function (props) {
  return props.width;
}); // eslint-disable-next-line react/display-name


var _default = function _default(props) {
  return _react.default.createElement(BoundingBox, _extends({}, props, {
    className: "bounding-box"
  }));
};

exports.default = _default;

var FourCornersStyled = _styledComponents.default.div.withConfig({
  displayName: "bounding-box__FourCornersStyled",
  componentId: "sc-1fdulxe-2"
})(["position:absolute;bottom:0;left:0;right:0;top:0;opacity:0;transition:opacity 200ms ease-in-out;"]);

exports.FourCornersStyled = FourCornersStyled;

var border = function border(color) {
  return "1px solid ".concat(color);
};

var cornerStyles = "\n  position: absolute;\n  padding-bottom: 20px;\n  width: 20px;\n";

var BottomLeft = _styledComponents.default.div.withConfig({
  displayName: "bounding-box__BottomLeft",
  componentId: "sc-1fdulxe-3"
})(["", " left:0;bottom:0;border-bottom:", ";border-left:", ";"], cornerStyles, function (_ref5) {
  var primaryColor = _ref5.primaryColor;
  return border(primaryColor);
}, function (_ref6) {
  var primaryColor = _ref6.primaryColor;
  return border(primaryColor);
});

var BottomRight = _styledComponents.default.div.withConfig({
  displayName: "bounding-box__BottomRight",
  componentId: "sc-1fdulxe-4"
})(["", " right:0;bottom:0;border-bottom:", ";border-right:", ";"], cornerStyles, function (_ref7) {
  var primaryColor = _ref7.primaryColor;
  return border(primaryColor);
}, function (_ref8) {
  var primaryColor = _ref8.primaryColor;
  return border(primaryColor);
});

var TopLeft = _styledComponents.default.div.withConfig({
  displayName: "bounding-box__TopLeft",
  componentId: "sc-1fdulxe-5"
})(["", " left:0;top:0;border-left:", ";border-top:", ";"], cornerStyles, function (_ref9) {
  var primaryColor = _ref9.primaryColor;
  return border(primaryColor);
}, function (_ref10) {
  var primaryColor = _ref10.primaryColor;
  return border(primaryColor);
});

var TopRight = _styledComponents.default.div.withConfig({
  displayName: "bounding-box__TopRight",
  componentId: "sc-1fdulxe-6"
})(["", " right:0;top:0;border-right:", ";border-top:", ";"], cornerStyles, function (_ref11) {
  var primaryColor = _ref11.primaryColor;
  return border(primaryColor);
}, function (_ref12) {
  var primaryColor = _ref12.primaryColor;
  return border(primaryColor);
});

var FourCorners = function FourCorners(_ref13) {
  var primaryColor = _ref13.primaryColor,
      cornerSize = _ref13.cornerSize;
  return _react.default.createElement(FourCornersStyled, null, _react.default.createElement(TopLeft, {
    cornerSize: cornerSize,
    primaryColor: primaryColor
  }), _react.default.createElement(TopRight, {
    cornerSize: cornerSize,
    primaryColor: primaryColor
  }), _react.default.createElement(BottomRight, {
    cornerSize: cornerSize,
    primaryColor: primaryColor
  }), _react.default.createElement(BottomLeft, {
    cornerSize: cornerSize,
    primaryColor: primaryColor
  }));
};

exports.FourCorners = FourCorners;